export default __webpack_public_path__ + "static/media/buyedPro-bg.cdb565d8.png";